<template>
	<div class="1Wontainer" style="padding-top: 0rem;">
		<div class="row">
			<div class="col-lg-12">
				<div class="support-index content-box ">
					<div class="support-ticket-content-w folded-info">
						<div class="support-ticket-content ">
							<div class="ticket-thread">
								<div class="element-box " style="-webkit-box-shadow: none; box-shadow: none;">
									<div class="section-headingM">
										<h1>Certainly</h1>
										 
										<p>/ˈsəːt(ə)nli/</p>
										<p>used to emphasize the speaker's belief that what is said is true.</p>
										<p>Use Certainly is online tool to help you estabilish your belief.</p>
									
									</div>	
									<div class="section-headingM">
										<h1>Peek visualy into what your finances may be</h1>
										<p>Uncertainty scenarios modeling</p>
										<p>Investment modeling</p>
										<p>Savings runaway modeling</p>
										<p>Track your budget </p>
										<p>TBD messaging</p>
									</div>
									<div class="section-headingM">
										<h1>Works great for people like you!</h1>
										<p>For moms and dads</p>
										<p>For students</p>
										<p>For investors</p>
										<p>For small bussiness owners</p>
									
										<p>Impact </p>
									</div>
									<div class="section-headingM">
										<h1>Get your answers fast</h1>
										<p>How much money I need to do ... ?</p>
										<p>How much money I will make if ...?</p>
										<p>Should I do campaign for ...?</p>
										<p><br /></p>
									
										<p>How many days my rainy days fund last if ...?</p>
										<p>How much I can safe by doing ...?</p>
										<p>How much I can get by not doing ...?</p>
										<p>When I will have ...?</p>
									</div>
									<div class="section-headingM">
										<h1>Examples</h1>
										<p>Restaurant</p>
										<p><a @click.prevent="editBalance" class="pop" style="padding-left: 8px;padding-right: 8px; cursor: pointer;"><i class="icon-feather-link" style="color:#6f42c1;"></i> <span style="color: black;"> Restaurant</span> </a></p>
										<p>Student trip</p>
										<p>Vacation</p>
										<p>Hotel</p>
										<p><br /></p>
									
									</div>
									<div class="section-headingM">
										<h1>Things to finish <small class="text-muted"> /notes</small></h1>
										<p>
												<s>Charts</s> <br />
							<s>Table editing</s> <br />
							<s>Scenario builder</s> <br />
							<s>Menu edit helpers</s> <br />
							Scenarios list <br />
							<s>Current funds</s> <br />
							Display break even <br />
							Display days runway <br />
							Saving data (autosave) and user accounts <br />
							Share by url link<br />
							To continue, please pruchase license (time limited free access) <br />
							usecertainly.app <br />
						
										</p>
									</div>
									<div class="section-headingM">
										<h1>Journal <small class="text-muted"></small></h1>
										<ul>
											<span>25-04-2020 <h5 style="display: inline;">Inital prototype</h5></span>
											<ul>4 days to complete [21 Mar - 25 Mar]</ul>
											<ul>24h estimated</ul>
											<ul>34h 12m time spent</ul>
										</ul>
									</div>
									<!--
									<h2 class="1form-header">Welcome</h2>
									<div class="form-desc">Use the included utility </div>
									<div class="element-box-content">
										<h3>Fancy display heading <small class="text-muted">With faded secondary text</small></h3>
									</div>
									-->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
export default {
  name: 'Welcome',
}
/*
							*/
</script>
<style>
.section-headingM {
    padding: 5% 10%;
    font-size: 1.26rem;
    color: rgba(0,0,0,0.5);
}
</style>
